import React from 'react';
import { Box, Section, Image } from '@common/components';
import { Button, Row, Col, Typography, Tag } from 'antd';
import { DeleteFilled, EditFilled } from '@ant-design/icons';

const Admin = ({ admin, onClick, onEdit, onDelete }) => {
	return (
		<Box className="p-5" onClick={() => onClick && onClick(admin)}>
			<Section className="mb-3" hoverable shadowed>
				<Image src={admin?.thumbnail?.path} width="100%" mb={20} />
				<Row type="flex" className="login-links">
					<Col>
						<Typography.Title level={4}>
							{admin?.user?.firstName} {admin?.user?.lastName}
						</Typography.Title>
						<Box>
							{admin?.modules?.map((module) => (
								<Tag>{module.title}</Tag>
							))}
						</Box>
					</Col>
				</Row>
				<Box textAlign="right">
					{onEdit && (
						<Button
							size="small"
							type="text"
							onClick={() => onEdit && onEdit(admin)}>
							<EditFilled style={{ color: '#FFCC00' }} />
						</Button>
					)}
					{onDelete && (
						<Button
							size="small"
							type="text"
							onClick={() => onDelete && onDelete(admin)}>
							<DeleteFilled style={{ color: '#FF0000' }} />
						</Button>
					)}
				</Box>
			</Section>
		</Box>
	);
};

export default Admin;
